function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0F7986"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M64.409,243.433c6.767-4.619,15.977-15.639,19.113-23.459c2.388-5.972,6.032-9.367,8.822-10.836 c-0.993-3.298,1.45-7.588,4.489-10.516c2.139,1.57,2.278,1.889,4.291,4.25c10.859-3.51,28.299-1.21,40.525,8.013 c33.916,25.62,26.877,109.641,12.429,130.282c1.123,0.111,3.478,0.933,4.171,3.852c0.624,2.54-1.838,4.568-2.845,4.619h0.369 l4.397,28.775h0.564c0,0,2.438,1.912,3.266,3.972c0.822,2.06,0.831,6.161,0.831,6.161H76.634c0,0,0.231-4.078,0.928-6.027 c0.721-1.944,3.178-4.111,3.178-4.111h0.568l3.515-28.775h-0.304c-1.016-0.051-3.492-2.078-2.835-4.619 c0.67-2.91,3.007-3.737,4.138-3.852c-1.977-1.594-8.563-8.725-3.275-30.322c6.166-25.168,32.137-46.354,31.782-59.346 c-0.102-3.977-7.999-3.519-8.115-0.661c-0.199,5.496-3.33,10.467-14.896,7.27c-6.36-1.76-8.217,2.327-12.933,4.162 c-4.61,1.788-5.505,3.953-9.69,6.097c0,0-4.282-4.041-7.358-10.11c-2.835-5.593-4.614-9.565,3.076-14.822L64.409,243.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M443.208,381.843c-0.789-2.171-3.515-4.577-3.515-4.577h-0.702l-3.834-33.02h2.037 c1.011-0.046,3.468-1.986,2.817-4.406c-0.735-3.034-3.431-3.7-4.401-3.7h-0.974c-7.607-14.471-17.431-55.213-20.257-72.261h8.563 c2.443,0,4.438-2.009,4.438-4.489s-1.991-4.489-4.438-4.489h-10.36l-0.023-0.204c9.02-4.429,15.242-13.889,15.242-24.803 c0-15.177-12.031-27.463-26.872-27.463s-26.863,12.291-26.863,27.463c0,10.914,6.208,20.373,15.219,24.803l-0.014,0.204h-10.356 c-2.452,0-4.443,2.014-4.443,4.489s1.991,4.489,4.443,4.489h8.563c-2.781,16.979-10.868,55.647-17.805,72.261h-1.658 c-0.97,0-3.681,0.661-4.415,3.7c-0.647,2.425,1.824,4.364,2.831,4.406h1.325l-4.804,33.02h-0.716c0,0-2.711,2.125-3.63,4.424 c-0.914,2.291-0.928,6.859-0.928,6.859h86.593c0,0-0.258-4.535-1.044-6.702L443.208,381.843z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M222.135,165.684l-9.727,121.94h101.668l-9.732-121.94l2.231-18.549h-87.064l2.628,18.549H222.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB937"
    },
    d: "M314.081,287.624l-9.732-121.94l2.231-18.549h-15.458L314.081,287.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M326.607,358.199l-5.658-54.252H206.575l-7.104,54.252h127.142H326.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB937"
    },
    d: "M326.607,358.199l-5.658-54.252h-16.106L326.607,358.199z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M326.381,356.015H199.753c-16.868,3.478-24.327,12.392-24.354,32.53H350.69 c-0.993-19.962-6.955-28.451-24.314-32.53H326.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M327.586,295.066c-1.09-6.115-6.305-7.436-7.732-7.436c-1.058,0-37.37,0-53.698,0 c0,0-3.852,0-9.57,0c-16.355,0-47.975,0-49.037,0c-1.432,0-6.314,1.515-7.404,7.612c-0.951,4.863,3.58,8.614,5.067,8.711 c0.887,0.019,39.804,0,56.145,0c16.327,0,59.938,0.019,60.824,0C323.693,303.856,328.547,299.929,327.586,295.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M306.575,147.136c0,0,11.242-11.968,17.556-27.376c6.305-15.45,7.875-37.357,7.875-37.357h-34.382 c0,0-1.533,30.364-9.062,30.364c-7.496,0-10.143-30.364-10.143-30.364h-30.77c0,0-3.718,30.364-10.291,30.364 c-6.6,0-8.905-30.364-8.905-30.364h-34.382c0,0,0.735,18.35,7.866,37.357c7.159,19.002,17.575,27.376,17.575,27.376H306.575z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);
export default __webpack_public_path__ + "static/media/cad.0d300beca8463981fbb446e7375c0469.svg";
export { ForwardRef as ReactComponent };